export default __webpack_public_path__ + "static/media/72984883_padded_logo.cfdb45d9.png";